module.exports = __webpack_public_path__ + "img/89.ba31adc5.jpg";